import Xmark from '@gef-ui/material-icons/Xmark';
import IconButton from '@mui/material/IconButton';
import React from 'react';
const CrossButton = (props)=>/*#__PURE__*/ React.createElement(IconButton, {
        ...props,
        // size="large"
        sx: (theme)=>({
                position: 'absolute',
                right: theme.spacing(1),
                color: 'grey.500',
                top: theme.spacing(0.75)
            })
    }, /*#__PURE__*/ React.createElement(Xmark, {
        fontSize: "large"
    }));
export default CrossButton;
